import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { useMutation, useQuery } from "@tanstack/react-query";
import GKSearchSelect from "components/GKSearchSelect";
import SmallSpinner from "components/Spinners/SmallSpinner";
import { useFormik } from "formik";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import toast from "react-hot-toast";
import axiosInstance from "utils/axiosInstance";

const Internal = () => {
  const [benchmark, setBenchmark] = useState<any[]>([]);
  const [advisorCompany, setAdvisorCompany] = useState<any[]>([]);

  const { isFetching: advisorCompanyLoading } = useQuery({
    queryKey: ["companies"],
    queryFn: () => axiosInstance.get("/super_admin/companies/"),
    onSuccess: (response: any) => {
      setAdvisorCompany(
        response?.data?.data.map((dataItem: any) => {
          return {
            name: `${dataItem?.name} - ${dataItem?.id}`,
            value: dataItem?.id,
          };
        }) || []
      );
    },
  });

  const { isFetching } = useQuery({
    queryKey: ["Benchmark"],
    queryFn: () => axiosInstance.get(`/instruments/list/`),
    onSuccess: (response: any) => {
      setBenchmark(
        response?.data?.data.map((dataItem: any) => {
          return {
            ...dataItem,
            name: dataItem?.companyName,
            value: dataItem?.gridCode,
          };
        }) || []
      );
    },
  });

  const { mutate: benchmarkReport, isLoading } = useMutation({
    mutationKey: ["benchmark-report"],
    mutationFn: (values: any) =>
      axiosInstance.post(`/super_admin/benchmark-report/`, values),
    onSuccess: (response) => {
      toast.success(
        response?.data?.message || "Created Benchmark Report Successfully"
      );
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const formik = useFormik({
    initialValues: {
      id: "",
      benchmark: "",
    },
    onSubmit: (values) => {
      benchmarkReport(values);
    },
  });

  return (
    <DashboardLayout title="Internal">
      <form onSubmit={formik.handleSubmit}>
        <Accordion
          expanded
          style={{
            border: `solid 1px var(--neutral-100)`,
            borderRadius: "8px",
            boxShadow: "none",
            background: "none",
          }}
        >
          <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
            <Typography fontSize={16} fontWeight={600}>
              Benchmark comparison for all portfolios.
            </Typography>
          </AccordionSummary>
          <Divider />
          <AccordionDetails>
            <Grid2 container spacing={2}>
              <Grid2 size={12}>
                <GKSearchSelect
                  requiredField
                  inputLabel="Advisor Company"
                  loading={advisorCompanyLoading}
                  options={advisorCompany || []}
                  onChange={(event, val) =>
                    formik.setFieldValue("id", val?.value)
                  }
                  getOptionLabel={(opt) =>
                    typeof opt === "object" ? opt.name : String(opt)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      placeholder="Select Advisor Company Name"
                      fullWidth
                    />
                  )}
                />
              </Grid2>
              <Grid2 size={12}>
                <GKSearchSelect
                  requiredField
                  inputLabel="Benchmark"
                  loading={isFetching}
                  options={benchmark || []}
                  onChange={(event, val) =>
                    formik.setFieldValue("benchmark", val?.value)
                  }
                  getOptionLabel={(option) => option?.name || option}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      variant="outlined"
                      placeholder="Select Benchmark"
                      fullWidth
                    />
                  )}
                />
              </Grid2>
              <Grid2
                size={12}
                display={"flex"}
                justifyContent={"flex-end"}
                alignContent={"center"}
              >
                <Button type="submit" variant="contained" color="primary">
                  {isLoading ? <SmallSpinner /> : "Submit"}
                </Button>
              </Grid2>
            </Grid2>
          </AccordionDetails>
        </Accordion>
      </form>
    </DashboardLayout>
  );
};

export default Internal;
